import { createContext, useContext } from 'react';
export const HeaderCardContext = createContext({
    obfuscated: false,
    setObfuscated: () => void 0,
});
export const useHeaderCardContext = () => useContext(HeaderCardContext);
//# sourceMappingURL=HeaderCardContext.js.map